const videos = () => {
    const videoContainer = document.querySelector('.video-container');
    if (videoContainer) {
        const video       = document.querySelector('[data-element="main-video"]');
        const videoSource = document.querySelector('[data-element="video-source"]');
        const poster      = document.querySelector('[data-element="video-poster"]');
        const canvas      = document.querySelector('[data-element="poster-canvas"]');
        const ctx         = canvas.getContext('2d');

        const DESKTOP_VIDEO = video.dataset.desktopVideo;
        const MOBILE_VIDEO  = video.dataset.mobileVideo;

        const mobileMediaQuery = window.matchMedia('(max-width: 768px)');

        function isMobile() {
            return mobileMediaQuery.matches || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        }

        function selectVideo() {
            const mobile    = isMobile();
            const videoUrl  = mobile ? MOBILE_VIDEO : DESKTOP_VIDEO;
            videoSource.src = videoUrl;
            video.load();
        }

        function createPoster() {
            video.currentTime = 0.1;
        }

        video.addEventListener('loadeddata', () => {
            canvas.width  = video.videoWidth;
            canvas.height = video.videoHeight;

            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

            const posterUrl = canvas.toDataURL('image/jpeg', 0.8);
            poster.src      = posterUrl;

            video.currentTime = 0;
        });

        video.addEventListener('canplaythrough', () => {
            poster.classList.add('hidden');
        });

        video.addEventListener('play', () => {
            poster.classList.add('hidden');
        });

        video.addEventListener('error', () => {
            console.log('Ошибка загрузки видео');
        });
        mobileMediaQuery.addEventListener('change', (e) => {
            const wasMobile   = videoSource.src.includes('ElephantsDream');
            const isNowMobile = e.matches;

            if (wasMobile !== isNowMobile) {
                selectVideo();
                createPoster();
            }
        });

        selectVideo();
        createPoster();
    }
};

export default videos;
